module.exports = __webpack_public_path__ + "img/hero-award-bg.a4e05fb2.jpg";